// src/utils/errorHandler.js
import Vue from 'vue'
import { MessageBox, Message } from 'element-ui'
import { safeStorage } from './cryptoJS'

export default {
    install() {
        let isMessageBoxVisible = false;
        Vue.prototype.$handleError = function (res) {
            if (!res) {
                Message.error('响应体为空')
                return
            }
            if (res.code == 401) {
                if (!isMessageBoxVisible) {
                    isMessageBoxVisible = true
                    MessageBox.confirm("登录失效，是否重新登录", "提示", {
                        showClose: false,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if (this.$route.path !== '/login') {
                            this.$router.replace("/login")
                        }
                    }).catch(() => {

                    }).finally(() => {
                        isMessageBoxVisible = false
                    })
                }

            } else {
                Message.error(res.msg || '请求失败')
            }
        }
    }
}